export const home = {
myReports: {
title: "بلاغاتك",
},
meta: {
untitledJob: "مهمة بلا عنوان",
noAssetLinked: "لا أصل مرتبط",
unassigned: "غير مُعيَّن",
emDash: "—",
},
aggregation: {
scheduledInspectionFallback: "تفتيش مجدول",
jobOverdueSubtitle: "{{asset}} · الاستحقاق {{date}}",
jobOverdueNoDate: "{{asset}} · متأخر",
jobOverdueUnassigned: "أمر عمل متأخر",
inspectionOverdueSubtitle: "{{asset}} · كان مستحقًا في {{date}}",
requestOverdueSubtitle: "{{asset}} · كان مستحقًا في {{date}}",
jobDueTodaySubtitle: "{{asset}} · مستحق اليوم",
inspectionDueTodaySubtitle: "{{asset}} · مستحق اليوم",
inspectionScheduledSubtitle: "{{asset}} · مجدول في {{date}}",
jobInProgressSubtitle: "{{asset}} · قيد التنفيذ",
followOnApprovalSubtitle: "{{asset}} · موافقة متابعة",
completionReviewSubtitle: "{{asset}} · مراجعة الإنجاز",
scheduledBadge: "مجدول",
inProgressBadge: "قيد التنفيذ",
approvalBadge: "موافقة",
requestSubtitle: "{{asset}} · متابعة",
followUpQueuePending: "جديد",
followUpQueueAwaitingCustomer: "في انتظار العميل",
followUpQueueApproved: "موافق عليه",
followUpQueueScheduled: "مجدول",
followUpQueueConverted: "عمل مرتبط",
followUpQueueRejected: "مرفوض",
certificateActionsTitle: "شهادات مستحقة",
certificateActionsEmpty: "لا شهادات مستحقة",
certificatePendingValidation: "بانتظار التصديق",
certificateRejected: "مرفوض",
certificateExpired: "منتهي الصلاحية",
certificateExpiringSoon: "قارب على الانتهاء",
},
greeting: {
morning: "صباح الخير",
afternoon: "مساء الخير",
evening: "مساء الخير",
withName: "{{greet}}، {{name}}",
},
screen: {
title: "الرئيسية",
loadingCommandCenter: "جارٍ تحميل صفحتك الرئيسية…",
},
summaryStrip: {
assets: "الأصول",
openJobs: "أوامر العمل المفتوحة",
dueToday: "مستحق اليوم",
requests: "الطلبات",
},
commandQuickActions: {
scanQr: "مسح رمز QR",
},
commandEmpty: {
dueToday: "لا شيء مستحق اليوم.",
needsAttention: "لا يوجد ما يتطلب انتباهك الآن.",
requests: "لا طلبات بعد. ستظهر طلبات الأصول المشتركة هنا.",
recentActivity: "لا نشاط حديث.",
},
commandSectionTitles: {
overdue: "متأخر",
dueToday: "مستحق اليوم",
requests: "الطلبات",
recentActivity: "النشاط الأخير",
},
commandCenter: {
statusBar: {
actionRequired: "إجراء مطلوب",
needsAttention: "يحتاج إلى اهتمام",
allSystemsNormal: "جميع الأنظمة طبيعية",
synced: "تمت المزامنة {{label}}",
},
aiBriefing: {
label: "موجز العمليات",
readMore: "قراءة الملخص ←",
},
attentionQueue: {
title: "قائمة الانتظار ذات الأولوية",
empty: "صندوق الوارد فارغ. لا يوجد ما يتطلب انتباهك الآن.",
showMore: "{{count}} أخرى ←",
snooze: "تأجيل",
kind: {
request: "الطلبات",
inspection: "عمليات الفحص",
job: "المهام",
document: "المستندات",
activity: "النشاط",
},
},
counters: {
dueInspections: "التفتيشات المستحقة",
openRequests: "الطلبات المفتوحة",
openJobs: "أوامر العمل المفتوحة",
workQueue: "قائمة العمل",
},
recentActivity: {
title: "النشاط الأخير",
defaultEmpty: "لا يوجد نشاط اليوم حتى الآن.",
events_zero: "لا أحداث",
events_one: "حدث واحد",
events_two: "حدثان",
events_few: "{{count}} أحداث",
events_many: "{{count}} حدثًا",
events_other: "{{count}} حدث",
},
},
empty: {
firstAssetTitle: "أنشئ أول أصل",
firstAssetSubtitle: "أضف أصلًا لبدء التفتيشات وإدارة العمل.",
noAssetsInScopeTitle: "لا أصول في {{scope}}",
noAssetsInScopeSubtitle: "غيّر مرشح النطاق أعلاه أو أضف أصولًا لهذا الفريق.",
noAssetsInScopeSubtitleWeb: "غيّر النطاق أو امسح البحث — الأصول المطابقة تظهر هنا.",
noAssetsInScopeShortWeb: "غيّر النطاق أو أضف أصولًا لهذا الفريق.",
addAsset: "إضافة أصل",
},
planNudge: {
asset_cap_limited: "بقي أصل واحد في خطتك ({{limit}} مضمّن). تتضمن {{plan}} {{nextLimit}}.",
asset_cap: "تبقّى أصل واحد في خطتك ({{limit}} مشمولة). خطة {{plan}} بلا حد.",
same_contact: "أرسلت إلى {{name}} {{count}} مهام هذا الشهر. مع {{plan}} يراها ويحدّثها بنفسه.",
addresses: "أصولك موزعة على {{count}} عناوين. المواقع في {{plan}} تجمع العمل حسب المكان.",
inspections: "{{count}} فحصًا في أسبوع كثير على شخص واحد. الفرق في {{plan}} تتقاسم العبء.",
seePlans: "عرض {{plan}}",
dismiss: "ليس الآن",
},
teamSetup: {
title: "إعداد فريقك",
dismiss: "إخفاء إعداد الفريق",
steps: {
invite: "دعوة زميل",
site: "إضافة موقع",
requests: "السماح للآخرين بطلب العمل (مشاركة أصل)",
},
},
firstRun: {
progress: "{{completed}} من {{total}}",
gettingStartedDefault: "البدء",
dismissDefault: "إخفاء قائمة البدء",
trySampleDefault: "جرب عينة",
removeSampleDefault: "إزالة النموذج",
title: "ابدأ هنا",
subtitle: "اضغط على خطوة. كل خطوة تُريك بالضبط أين تضغط.",
trySample: "جرّب نموذجًا",
removeSample: "إزالة النموذج",
createAsset: "إنشاء أصل",
startInspection: "بدء تفتيش",
dismiss: "ليس الآن",
whatIsThis: "ما هذا؟",
whatIsThisBody: "يجمع AssetWRX أصولك وعمليات الفحص والأعمال في مكان واحد، لتعرف دائمًا ما الذي يجب فعله بعد ذلك.",
busy: "جارٍ الإعداد…",
error: "تعذر إعداد النموذج. لا يزال بإمكانك إنشاء أصل يدويًا.",
suggested: "مقترح",
steps: {
  document: "أضف شهادة",
asset: "أضف أصلك الأول",
request: "شارك أصلًا مع شخص ما",
inspection: "جدوِل فحصًا",
job: "أنشئ مهمة",
contacts: "ادعُ زميلًا",
contactsNoTeams: "أضف جهة اتصال",
},
coachmark: {
title: "ابدأ من هنا",
body: "اضغط على أي خطوة للبدء. يمكنك تنفيذها بأي ترتيب.",
dismiss: "فهمت",
},
},
web: {
commandOverline: "بحث وإنشاء",
commandHint: "ابحث في مساحة العمل، حدد النطاق، أو أضف أصولًا ومهامًا وتفتيشات.",
searchPlaceholder: "البحث في الأصول والمهام والتفتيشات والتقارير…",
overviewTitle: "نظرة عامة",
overviewHint: "اختصارات وأعداد مباشرة لنطاقك. انقر على مؤشر للقائمة الكاملة.",
overviewSnapshotLabel: "لقطة",
overviewSnapshotHintWeb: "أصول · تفتيشات · مهام — انقر على بطاقة لفتح قائمتها",
suggestedActionsTitle: "إجراءات مقترحة",
suggestedActionsHint: "أولويات مبنية على قواعد في هذا النطاق. افتح بطاقة للانتقال إلى القائمة أو المهمة المناسبة.",
workQueueTitle: "قائمة انتظار العمل",
workQueueHint: "مهام وتفتيشات مُرتّبة لهذا النطاق. اختر صفًا للتفاصيل.",
activeWorkQueueTitle: "قائمة انتظار نشطة",
workQueueSectionMeta: "مهام وتفتيشات وجداول — صفِّ أو افتح صفًا للتفاصيل.",
queueEmptyNoItems: "لا مهام أو تفتيشات قابلة للإجراء في هذا النطاق.",
queueEmptyNoFilter: "لا عناصر تطابق هذا المرشح.",
automationHint: "تحويلات واقتراحات مهام من تفتيشات مكتملة ودعوات فريق.",
detailJobTitle: "تفاصيل المهمة",
detailOverviewTitle: "نظرة عامة",
detailEmpty: "لا عناصر عمل في هذا النطاق بعد. استخدم الإنشاء السريع في الشريط.",
detailCommandSummary: "ملخص مركز القيادة",
detailIdleLead: "اختر أي صف في القائمة للتفاصيل والإجراءات الرئيسية والنشاط الأخير.",
detailStatOpenJobs: "مهام مفتوحة",
detailStatOverdue: "متأخرة",
detailStatUnassigned: "غير مُعيَّنة",
detailNextUp: "التالي في القائمة",
viewAssetDetailsA11y: "عرض كل تفاصيل الأصل",
scheduleWorkA11y: "جدولة العمل",
moreActions: "المزيد من الإجراءات",
moreActionsA11y: "المزيد من الإجراءات",
copilotSectionTitle: "مساعد العمليات",
copilotEmptyTitle: "لا توجد إشارات ذات أولوية",
copilotEmptyBody: "لا يوجد ما يستدعي الانتباه في هذا النطاق بعد. عدّل المرشحات أو أضف عملاً أو راجع الرؤى والعمل لمعرفة الاتجاهات.",
copilotDockHint: "أولويات مبنية على قواعد لنطاقك الحالي. كل بطاقة تربط بالقائمة أو المهمة المناسبة.",
},
snapshot: {
inspectionsSublabelDrafts: "مسودات ومتوقفة",
inspectionsSublabelScheduled_one: "مسودات ومتوقفة · فحص واحد مجدول",
inspectionsSublabelScheduled_other: "مسودات ومتوقفة · {{count}} مجدول",
jobsSublabelNotClosed: "غير مغلقة",
jobsSublabelOverdue_one: "غير مغلقة · واحد متأخر",
jobsSublabelOverdue_other: "غير مغلقة · {{count}} متأخر",
inThisScope: "في هذا النطاق",
findingsSublabel: "تقارير مكتملة بعناصر راسبة",
unassignedSublabel: "مهام مفتوحة بلا مالك",
inspectionsSublabelScheduled_zero: "مسودات ومتوقفة · لا شيء مجدول",
inspectionsSublabelScheduled_two: "مسودات ومتوقفة · فحصان مجدولان",
inspectionsSublabelScheduled_few: "مسودات ومتوقفة · {{count}} مجدولة",
inspectionsSublabelScheduled_many: "مسودات ومتوقفة · {{count}} مجدولًا",
jobsSublabelOverdue_zero: "غير مغلقة · لا شيء متأخر",
jobsSublabelOverdue_two: "غير مغلقة · اثنان متأخران",
jobsSublabelOverdue_few: "غير مغلقة · {{count}} متأخرة",
jobsSublabelOverdue_many: "غير مغلقة · {{count}} متأخرًا",
},
queueFilter: {
all: "كل العمل",
overdue: "متأخرة",
inProgress: "قيد التنفيذ",
dueSoon: "تستحق قريبًا",
},
queue: {
labels: {
asset: "أصل",
due: "الاستحقاق",
status: "الحالة",
assignee: "مُعيَّن إلى",
scheduled: "مجدول",
nextStep: "الخطوة التالية",
started: "بدأ",
priority: "الأولوية",
created: "أُنشئ",
location: "الموقع",
dueDate: "تاريخ الاستحقاق",
},
status: {
overdue: "متأخرة",
due: "مستحقة",
paused: "متوقفة",
inProgress: "قيد التنفيذ",
awaitingSchedule: "بانتظار الجدولة",
unassigned: "غير مُعيَّنة",
},
subtitle: {
overdue: "{{asset}} • متأخرة",
activeWork: "{{asset}} • عمل نشط",
dueThisWeek: "{{asset}} • مستحقة هذا الأسبوع",
scheduledInspection: "{{asset}} • تفتيش مجدول",
needsSchedule: "{{asset}} • تحتاج جدولة",
unassigned: "{{asset}} • غير مُعيَّنة",
resumeChecklist: "{{asset}} • استئناف القائمة",
},
title: {
inspectionOverdue: "تفتيش متأخر",
inspectionDue: "تفتيش مستحق",
inspectionInProgress: "تفتيش قيد التنفيذ",
},
typeJob: "مهمة",
typeInspection: "تفتيش",
primaryOpenJob: "فتح المهمة",
primaryResumeInspection: "استئناف التفتيش",
primaryStartInspection: "بدء التفتيش",
openWork: "فتح العمل",
nextStepSetSchedule: "تعيين التاريخ والوقت",
nextStepAssign: "تعيين فريق أو مقاول",
},
sections: {
quickActions: "إجراءات سريعة",
quickActionsCardTitle: "اختصارات",
quickActionsHintSetup: "مسح وإنشاء عمل.",
quickActionsHintFull: "مسح وإنشاء عمل والانتقال للعاجل.",
snapshot: "لقطة",
snapshotHint: "أصول · تفتيشات · مهام — انقر للفتح",
myWork: "عملي",
myWorkHint: "تابع أو عيّن أو أنهِ ما تملكه.",
needsAttention: "يحتاج انتباهًا",
needsAttentionHint: "مجمّع حسب النوع — نفس العناصر بقراءة أسهل.",
workflowSuggestions: "اقتراحات سير العمل",
workflowHint: "نتائج سير تفتيش جاهزة للخطوة التالية.",
viewAll: "عرض الكل",
attentionQueue: "الانتباه",
attentionQueueCollapsedHint: "اضغط لعرض التفاصيل الكاملة حسب الأولوية",
attentionQueueShowLess: "عرض أقل",
attentionEmpty: "لا عمل عاجل في هذا النطاق.",
moreToolsTitle: "أدوات أخرى",
moreToolsBody: "الرؤى وموجز النشاط الكامل ومنضدة العمل.",
contractorInvitesBanner_one: "لديك دعوة لتقديم عرض سعر أو تنفيذ عمل — اضغط للرد",
contractorInvitesBanner_other: "لديك {{count}} دعوة لتقديم عرض سعر أو تنفيذ أعمال — اضغط للرد",
workspaceDeeperTitle: "إشارات أخرى",
workspaceDeeperSummary: "الجداول والعمل النشط والنشاط.",
commandShortcutsTitle: "أنشئ أو افتح",
commandShortcutsSummary: "أضف عملاً أو افتح الطابور التالي.",
jumpToTitle: "افتح",
jumpToSummary: "السجلات والتقارير.",
contractorInvitesBanner_zero: "لا دعوات لتقديم عرض سعر أو تنفيذ عمل",
contractorInvitesBanner_two: "لديك دعوتان لتقديم عرض سعر أو تنفيذ عمل — اضغط للرد",
contractorInvitesBanner_few: "لديك {{count}} دعوات لتقديم عرض سعر أو تنفيذ أعمال — اضغط للرد",
contractorInvitesBanner_many: "لديك {{count}} دعوة لتقديم عرض سعر أو تنفيذ أعمال — اضغط للرد",
},
welcome: {
subtitleDefault: "عمل اليوم",
subtitleRecipient: "تقارير وأوامر عمل مشتركة تحتاج إلى ردّك",
},
kpiStrip: {
pendingReviews: "المراجعات",
pendingReviewsSub: "بانتظار ردّك",
complianceSub: "المستندات والتفتيشات المتأخرة",
},
attentionGroups: {
approvals: "الموافقات والمراجعات",
people: "الأشخاص والردود",
time: "الوقت والمخاطر",
},
tasks: {
jobInvitations: {
title: "دعوات مهام",
sub: "قبول أو رفض",
},
yourTurn: {
title: "دورك",
sub: "قبول أو رفض المهمة",
},
reworkRequested: {
title: "طُلب إعادة عمل",
sub: "إعادة تعيين المهمة",
},
workInProgress: {
title: "عمل قيد التنفيذ",
sub: "إكمال أو نشر تحديث",
},
scheduleProposed: {
title: "جدول مقترح",
sub: "تعيين التاريخ والوقت",
},
approvedRepairs: {
title: "إصلاحات موافَق عليها",
sub: "تحويل إلى مهام",
},
unassignedWork: {
title: "عمل غير مُعيَّن",
sub: "تعيين فريق أو مقاول",
},
draftInspection: {
title: "تفتيش مسودة",
sub: "استئناف",
},
inspectionDue: {
title: "تفتيش مستحق",
sub: "متأخر أو 60+ يومًا",
},
criticalIssues: {
title: "قضايا حرجة",
sub: "صحة ضعيفة",
},
followOnProposed: {
title: "متابعة مقترحة",
sub: "الموافقة أو الرفض قبل التعيين",
},
completionSubmitted: {
title: "أُرسل الإكمال",
sub: "الموافقة أو طلب إعادة عمل",
},
reportAwaitingReview: {
title: "تقرير بانتظار المراجعة",
sub: "الموافقة على الإصلاحات أو رفضها",
},
awaitingRecipient: {
title: "بانتظار المستلم",
sub: "مراجعة",
},
awaitingRecipientResponse: {
title: "بانتظار رد المستلم",
sub: "متابعة المراجعات المعلقة",
},
overdueJobs: {
title: "مهام متأخرة",
sub: "حل العمل المتعثر",
},
},
pinned: {
scanQr: "مسح QR",
inspect: "تفتيش",
createJob: "إنشاء مهمة",
},
contextual: {
reviewReport: "مراجعة التقرير",
respondToAssignment: "الرد على التعيين",
approveFollowOn: "الموافقة على المتابعة",
approveCompletion: "الموافقة على الإكمال",
continueJob: "متابعة المهمة",
resumeInspection: "استئناف التفتيش",
addAsset: "إضافة أصل",
},
webQuickCreate: {
createInspection: "إنشاء تفتيش",
createTemplate: "إنشاء قائمة تحقق",
createJob: "إنشاء مهمة",
scheduleWork: "جدولة العمل",
shortAsset: "أصل",
shortRequest: "طلب",
shortInspection: "تفتيش",
shortJob: "أمر عمل",
},
kpi: {
assets: "أصول",
inspections: "تفتيشات",
jobs: "مهام",
unassigned: "غير مُعيَّنة",
findings: "نتائج",
},
automation: {
approvedRepairsTitle: "إصلاحات موافَق عليها",
suggestedJobsTitle: "مهام مقترحة من التفتيش",
teamInvitesTitle: "دعوات الفريق",
},
urgency: {
critical: "حرج",
medium: "متوسط",
low: "منخفض",
},
priorityDot: {
a11y: "الأولوية {{level}}",
level: {
p1: "حرجة",
p2: "متوسطة",
p3: "منخفضة",
none: "غير محددة",
},
},
workLanes: {
kindLabel: {
request: "الطلبات",
inspection: "التفتيش",
job: "المهام",
},
kindLabelLower: {
request: "الطلبات",
inspection: "الفحوصات",
job: "المهام",
},
empty: "لا شيء يحتاجك هنا.",
viewAll: "عرض جميع {{kind}} ({{count}}) ←",
},
assetGroups: {
overdueBadge_zero: "{{count}} متأخرة",
overdueBadge_one: "{{count}} متأخرة",
overdueBadge_two: "{{count}} متأخرة",
overdueBadge_few: "{{count}} متأخرة",
overdueBadge_many: "{{count}} متأخرة",
overdueBadge_other: "{{count}} متأخرة",
needsYouBadge: "{{count}} لك",
openAssetMore: "فتح الأصل · {{count}} أخرى ←",
openAsset: "فتح الأصل ←",
moreAssets_one: "أصل آخر به عمل مفتوح",
moreAssets_other: "{{count}} أصل آخر به عمل مفتوح",
moreAssets_zero: "لا توجد أصول أخرى بها عمل مفتوح",
moreAssets_two: "أصلان آخران بهما عمل مفتوح",
moreAssets_few: "{{count}} أصول أخرى بها عمل مفتوح",
moreAssets_many: "{{count}} أصلًا آخر به عمل مفتوح",
},
sharedAssets: {
invitesA11y_one: "دعوة أصل واحدة — قبول أو رفض",
invitesA11y_other: "{{count}} دعوة أصل — قبول أو رفض",
invitesTitle_one: "تمت مشاركة أصل معك",
invitesTitle_other: "تمت مشاركة {{count}} أصل معك",
tapToAcceptOrDecline: "اضغط للقبول أو الرفض",
activeA11y: "{{name}} — تمت مشاركته معك. افتحه للإبلاغ عن مشكلة أو رؤية أعماله.",
activeSub: "تمت مشاركته معك · أبلغ عن مشكلة أو شاهد عملها",
invitesA11y_zero: "لا دعوات أصول",
invitesA11y_two: "دعوتا أصل — قبول أو رفض",
invitesA11y_few: "{{count}} دعوات أصول — قبول أو رفض",
invitesA11y_many: "{{count}} دعوة أصل — قبول أو رفض",
invitesTitle_zero: "لم تتم مشاركة أي أصل معك",
invitesTitle_two: "تمت مشاركة أصلين معك",
invitesTitle_few: "تمت مشاركة {{count}} أصول معك",
invitesTitle_many: "تمت مشاركة {{count}} أصلًا معك",
},
sectionCard: {
otherGroup: "أخرى",
emptyDefault: "لا شيء هنا بعد",
},
commandCentre: {
  showMeHow: "أرني كيف",
calendar: "التقويم",
stateLabel: {
actionNeeded: "مطلوب اتخاذ إجراء",
watch: "للمتابعة",
active: "نشط",
clear: "لا إجراء مطلوب",
},
eyebrow: {
needsYou: "يحتاج إليك",
now: "الآن",
decision: "قرار",
},
onYourPlate: "على عاتقك",
watchlist: "للمتابعة",
upNext: "التالي",
portfolioMovement: "ما الذي تغيّر",
workspaceSummary: "ملخص مساحة العمل",
toMonitor: "{{count}} للتحقق",
seeAll: "شاهد الكل",
seeAllA11y: "شاهد الكل {{count}}",
assetRowA11y: "{{name}}. {{state}}. {{reason}}",
signalLabels: {
needsYou: "يحتاج إليك",
atRisk: "معرّض للخطر",
inMotion: "نشطة",
dueSoon: "يحل قريبًا",
},
viewDetails: "عرض التفاصيل",
moreOnAsset_one: "عنصر آخر على {{name}} يحتاج إلى القرار نفسه",
moreOnAsset_other: "{{count}} عنصر آخر على {{name}} يحتاج إلى القرار نفسه",
moreOnAssetA11y_one: "عنصر آخر في {{name}} يحتاج إلى القرار نفسه. افتحه في العمل",
moreOnAssetA11y_other: "{{count}} عنصر آخر في {{name}} يحتاج إلى القرار نفسه. افتحها في العمل",
signalRowA11y: "{{action}}: {{name}}. {{reason}}",
moreOnAsset_zero: "لا مزيد على {{name}} يحتاج إلى القرار نفسه",
moreOnAsset_two: "عنصران آخران على {{name}} يحتاجان إلى القرار نفسه",
moreOnAsset_few: "{{count}} عناصر أخرى على {{name}} تحتاج إلى القرار نفسه",
moreOnAsset_many: "{{count}} عنصرًا آخر على {{name}} يحتاج إلى القرار نفسه",
moreOnAssetA11y_zero: "لا توجد عناصر أخرى في {{name}} تحتاج إلى القرار نفسه.",
moreOnAssetA11y_two: "عنصران آخران في {{name}} يحتاجان إلى القرار نفسه. افتحهما في العمل",
moreOnAssetA11y_few: "{{count}} عناصر أخرى في {{name}} تحتاج إلى القرار نفسه. افتحها في العمل",
moreOnAssetA11y_many: "{{count}} عنصرًا آخر في {{name}} يحتاج إلى القرار نفسه. افتحها في العمل",
},
decisionModel: {
action: {
confirm: "تأكيد",
reply: "رد",
review: "المراجعة",
resolve: "حل",
createWork: "إنشاء العمل",
resubmit: "إعادة الإرسال",
inviteMore: "قم بدعوة المزيد",
respond: "الرد",
open: "فتح",
quote: "عرض سعر",
triage: "قرّر",
resume: "استئناف",
start: "البدء",
continueJob: "متابعة",
inspect: "فحص",
},
reason: {
overdue: "العمل المتأخر يحتاج إلى الاهتمام",
blocked: "العمل متوقف ويحتاج إلى قرار",
doneConfirmWithName: "حدّد {{name}} هذا العمل كمكتمل — أكّد الإصلاح",
doneConfirm: "تم الانتهاء من العمل - قم بتأكيد الإصلاح",
visitConfirmWithName: "خطّط {{name}} لزيارة — تأكّد من إمكانية وجود شخص هناك، أو اطلب موعدًا مختلفًا",
visitConfirm: "تم التخطيط للزيارة - تأكد من إمكانية تواجد شخص ما هناك، أو اطلب موعدًا مختلفًا",
needMoreInfo: "يحتاج الفريق إلى مزيد من المعلومات منك",
waitingYourReview: "في انتظار مراجعتك",
waitingYourReviewWithName: "{{name}} في انتظار مراجعتك",
reviewWaiting: "هناك مراجعة أو موافقة في الانتظار",
approvedNoWorkYet: "معتمَد — لم يُنشأ العمل بعد",
reworkSentBackWithName: "أُعيد إلى {{name}} لإعادة العمل — بانتظار إكماله مرة أخرى",
reworkSentBack: "أُعيد لإعادة العمل — بانتظار إكماله مرة أخرى",
reworkOwnerRedo: "أُعيد لإعادة العمل — أعد العمل وأكمله مرة أخرى",
quotesDeclined: "رفض جميع المدعوين تقديم عرض سعر — ادعُ مزيدًا من المقاولين",
waitingRequesterConfirm: "في انتظار تأكيد مقدّم الطلب للإصلاح",
acceptOrDeclineYou: "مخصص لك - قم بالقبول أو الرفض قبل بدء العمل",
waitingAcceptWithName: "في انتظار قبول {{name}} أو رفضه",
waitingAccept: "في انتظار قبول المكلف أو رفضه",
waitingTriageWithName: "{{name}} في انتظار قرار",
waitingTriage: "مقدّم الطلب في انتظار قرار",
workspaceUnavailable: "تعذّر تحميل مساحة عملك. انقر للمحاولة مرة أخرى.",
dueToday: "يحل اليوم",
invitedToQuote: "أنت مدعو لتقديم عرض سعر — رُدّ بالسعر أو ارفض",
pausedWithReason: "متوقف مؤقتًا — {{reason}}. استئناف عندما تستطيع",
pausedResume: "متوقف مؤقتًا - استأنف عندما تستطيع",
onThisJob: "أنت مكلَّف بهذه المهمة — أكملها عند انتهاء العمل",
assignedStartOnSite: "مخصص لك - ابدأ عندما تكون في الموقع",
scheduledApproaching: "يقترب العمل المقرر",
pausedWithReasonOnly: "متوقف مؤقتًا — {{reason}}",
paused: "متوقف مؤقتًا",
inProgress: "العمل جار",
fallback: "مطلوب الاهتمام التشغيلي",
},
assetReason: {
actionRequired: "مطلوب اتخاذ إجراء",
criticalRisk: "مخاطر حرجة على الأصل",
elevatedRisk: "ارتفاع مخاطر الأصول",
operationalConcern: "مخاوف تشغيلية",
activeOrScheduled: "العمل نشط أو مجدول",
noException: "لا شيء يحتاج إلى اهتمام",
},
assetWatchSignal: {
criticalMonitor: "مخاطر حرجة على الأصل تتطلب المراقبة",
elevatedMonitor: "مخاطر مرتفعة على الأصل تتطلب المراقبة",
conditionNeedsAction: "الحالة تحتاج إلى إجراء",
},
brief: {
itemsNeed_one: "{{count}} عنصر يحتاج إلى الاهتمام.",
itemsNeed_other: "{{count}} عنصر يحتاج إلى الاهتمام.",
conditionsWatchClause_one: " عنصر واحد آخر للمتابعة.",
conditionsWatchClause_other: " {{count}} عنصر آخر للمتابعة.",
nothingNeedsYou: "لا شيء يحتاجك الآن.",
watchlist_one: "لا شيء يحتاجك الآن. عنصر واحد للمتابعة.{{motion}}",
watchlist_other: "لا شيء يحتاجك الآن. {{count}} عنصر للمتابعة.{{motion}}",
inMotionOnly_one: "لا شيء يحتاج إليك الآن. عنصر واحد مخطط أو قيد التنفيذ.",
inMotionOnly_other: "لا شيء يحتاج إليك الآن. {{count}} عنصر مخطط أو قيد التنفيذ.",
invitationsOnly_zero: "لا دعوات في انتظار ردك.",
invitationsOnly_one: "دعوة واحدة لتقديم عرض سعر أو تنفيذ عمل في انتظار ردك.",
invitationsOnly_two: "دعوتان لتقديم عرض سعر أو تنفيذ عمل في انتظار ردك.",
invitationsOnly_few: "{{count}} دعوات لتقديم عرض سعر أو تنفيذ أعمال في انتظار ردك.",
invitationsOnly_many: "{{count}} دعوة لتقديم عرض سعر أو تنفيذ أعمال في انتظار ردك.",
invitationsOnly_other: "{{count}} دعوة لتقديم عرض سعر أو تنفيذ أعمال في انتظار ردك.",
inMotionClause_one: " عنصر واحد مخطط أو قيد التنفيذ.",
inMotionClause_other: " {{count}} عنصر مخطط أو قيد التنفيذ.",
itemsNeed_zero: "لا توجد عناصر تحتاج إلى الاهتمام.",
itemsNeed_two: "عنصران يحتاجان إلى الاهتمام.",
itemsNeed_few: "{{count}} عناصر تحتاج إلى الاهتمام.",
itemsNeed_many: "{{count}} عنصرًا يحتاج إلى الاهتمام.",
conditionsWatchClause_zero: "",
conditionsWatchClause_two: " عنصران آخران للمتابعة.",
conditionsWatchClause_few: " {{count}} عناصر أخرى للمتابعة.",
conditionsWatchClause_many: " {{count}} عنصرًا آخر للمتابعة.",
watchlist_zero: "لا شيء يحتاجك الآن.{{motion}}",
watchlist_two: "لا شيء يحتاجك الآن. عنصران للمتابعة.{{motion}}",
watchlist_few: "لا شيء يحتاجك الآن. {{count}} عناصر للمتابعة.{{motion}}",
watchlist_many: "لا شيء يحتاجك الآن. {{count}} عنصرًا للمتابعة.{{motion}}",
inMotionOnly_zero: "لا شيء يحتاج إليك الآن. لا توجد عناصر مخططة أو قيد التنفيذ.",
inMotionOnly_two: "لا شيء يحتاج إليك الآن. عنصران مخططان أو قيد التنفيذ.",
inMotionOnly_few: "لا شيء يحتاج إليك الآن. {{count}} عناصر مخططة أو قيد التنفيذ.",
inMotionOnly_many: "لا شيء يحتاج إليك الآن. {{count}} عنصرًا مخططًا أو قيد التنفيذ.",
inMotionClause_zero: " لا عناصر مخططة أو قيد التنفيذ.",
inMotionClause_two: " عنصران مخططان أو قيد التنفيذ.",
inMotionClause_few: " {{count}} عناصر مخططة أو قيد التنفيذ.",
inMotionClause_many: " {{count}} عنصرًا مخططًا أو قيد التنفيذ.",
},
},
copilot: {
overdue: {
title: "عمل متأخر",
body_one: "أمر عمل مفتوح واحد بتاريخ استحقاق مضى. رتّب الجدولة أو الإغلاق.",
body_other: "{{count}} أمر عمل مفتوح بتاريخ استحقاق مضى. رتّب الجدولة أو الإغلاق.",
action: "فتح المهام",
body_zero: "لا أوامر عمل مفتوحة بتاريخ استحقاق مضى.",
body_two: "أمرا عمل مفتوحان بتاريخ استحقاق مضى. رتّب الجدولة أو الإغلاق.",
body_few: "{{count}} أوامر عمل مفتوحة بتاريخ استحقاق مضى. رتّب الجدولة أو الإغلاق.",
body_many: "{{count}} أمر عمل مفتوح بتاريخ استحقاق مضى. رتّب الجدولة أو الإغلاق.",
},
failedFindings: {
title: "نتائج التفتيش",
body_one: "فحص مكتمل واحد في هذا النطاق يتضمن عناصر راسبة. حوّل النتائج الحرجة إلى أوامر عمل.",
body_other: "{{count}} فحص مكتمل في هذا النطاق تتضمن عناصر راسبة. حوّل النتائج الحرجة إلى أوامر عمل.",
action: "التفتيشات",
body_zero: "لا فحوصات مكتملة في هذا النطاق تتضمن عناصر راسبة.",
body_two: "فحصان مكتملان في هذا النطاق يتضمنان عناصر راسبة. حوّل النتائج الحرجة إلى أوامر عمل.",
body_few: "{{count}} فحوصات مكتملة في هذا النطاق تتضمن عناصر راسبة. حوّل النتائج الحرجة إلى أوامر عمل.",
body_many: "{{count}} فحصًا مكتملًا في هذا النطاق تتضمن عناصر راسبة. حوّل النتائج الحرجة إلى أوامر عمل.",
},
throughput: {
title: "وتيرة الإكمال",
bodyUp: "تسارعت إكمالات المهام المؤكَّدة في النصف الثاني من آخر {{days}} يومًا.",
bodyDown: "تباطأت إكمالات المهام المؤكَّدة في النصف الثاني من آخر {{days}} يومًا. راجع العوائق.",
action: "قائمة انتظار العمل",
},
unassigned: {
title: "تغطية التعيين",
body_one: "أمر عمل مفتوح واحد بلا مسؤول. عيّن المسؤولين.",
body_other: "{{count}} أمر عمل مفتوح بلا مسؤول. عيّن المسؤولين.",
action: "المهام",
body_zero: "لا أوامر عمل مفتوحة بلا مسؤول.",
body_two: "أمرا عمل مفتوحان بلا مسؤول. عيّن المسؤولين.",
body_few: "{{count}} أوامر عمل مفتوحة بلا مسؤول. عيّن المسؤولين.",
body_many: "{{count}} أمر عمل مفتوح بلا مسؤول. عيّن المسؤولين.",
},
assetHealth: {
title: "أصول تحت ضغط",
body_one: "أصل واحد في هذا النطاق ضمن نطاق الصحة الضعيف (عمل مفتوح أو نتائج أو قِدم).",
body_other: "{{count}} أصل في هذا النطاق ضمن نطاق الصحة الضعيف (عمل مفتوح أو نتائج أو قِدم).",
action: "الأصول",
body_zero: "لا أصول في هذا النطاق ضمن نطاق الصحة الضعيف.",
body_two: "أصلان في هذا النطاق ضمن نطاق الصحة الضعيف (عمل مفتوح أو نتائج أو قِدم).",
body_few: "{{count}} أصول في هذا النطاق ضمن نطاق الصحة الضعيف (عمل مفتوح أو نتائج أو قِدم).",
body_many: "{{count}} أصلًا في هذا النطاق ضمن نطاق الصحة الضعيف (عمل مفتوح أو نتائج أو قِدم).",
},
allClear: {
title: "لقطة العمليات",
body: "لا إشارات عاجلة من Copilot في هذا النطاق لآخر {{days}} يومًا. راجع المخططات وحافظ على التعيينات.",
},
},
copilotCards: {
  sync: {
    primary: "اعرض التغييرات غير المرسلة",
    body_other: "{{count}} تغيير محفوظ على هذا الجهاز بانتظار الإرسال.",
    body_many: "{{count}} تغييرًا محفوظًا على هذا الجهاز بانتظار الإرسال.",
    body_few: "{{count}} تغييرات محفوظة على هذا الجهاز بانتظار الإرسال.",
    body_two: "تغييران محفوظان على هذا الجهاز بانتظار الإرسال.",
    body_one: "تغيير واحد محفوظ على هذا الجهاز بانتظار الإرسال.",
    body_zero: "لا تغييرات بانتظار الإرسال.",
    title: "تغييرات لم تُرسل بعد",
  },
  requests: {
    primary: "راجع الطلبات",
    body: "افتح الطلبات لترى مدى إلحاح كل منها وحوّلها إلى عمل.",
    title_other: "{{count}} طلب عاجل للمراجعة",
    title_many: "{{count}} طلبًا عاجلًا للمراجعة",
    title_few: "{{count}} طلبات عاجلة للمراجعة",
    title_two: "طلبان عاجلان للمراجعة",
    title_one: "طلب عاجل واحد للمراجعة",
    title_zero: "لا طلبات عاجلة",
  },
  brief: {
    draft: "اكتب خطة اليوم لـ {{overdue}} عناصر متأخرة و{{today}} مستحقة اليوم. ضع الأهم أولًا وكن موجزًا.",
    primary: "اقترح خطة",
    body: "{{overdue}} متأخرة و{{today}} مستحقة اليوم. يمكن للمساعد ترتيبها.",
    title: "خطّط لعمل اليوم",
  },
},
syncBanner: {
pending_zero: "المزامنة معلّقة: لا توجد تغييرات محفوظة دون اتصال بانتظار إعادة المحاولة.",
pending_one: "المزامنة معلّقة: تغيير واحد محفوظ دون اتصال بانتظار إعادة المحاولة.",
pending_two: "المزامنة معلّقة: تغييران محفوظان دون اتصال بانتظار إعادة المحاولة.",
pending_few: "المزامنة معلّقة: {{count}} تغييرات محفوظة دون اتصال بانتظار إعادة المحاولة.",
pending_many: "المزامنة معلّقة: {{count}} تغييرًا محفوظًا دون اتصال بانتظار إعادة المحاولة.",
pending_other: "المزامنة معلّقة: {{count}} تغيير محفوظ دون اتصال بانتظار إعادة المحاولة.",
},
healthEntries: {
ok: "سليم",
syncLabel: "المزامنة",
syncPending_zero: "{{count}} قيد الانتظار",
syncPending_one: "{{count}} قيد الانتظار",
syncPending_two: "{{count}} قيد الانتظار",
syncPending_few: "{{count}} قيد الانتظار",
syncPending_many: "{{count}} قيد الانتظار",
syncPending_other: "{{count}} قيد الانتظار",
syncUpToDate: "محدَّثة",
failedSyncsLabel: "مزامنات فاشلة",
failedSyncsCount_zero: "{{count}} فاشلة",
failedSyncsCount_one: "{{count}} فاشلة",
failedSyncsCount_two: "{{count}} فاشلة",
failedSyncsCount_few: "{{count}} فاشلة",
failedSyncsCount_many: "{{count}} فاشلة",
failedSyncsCount_other: "{{count}} فاشلة",
iotLabel: "إنترنت الأشياء",
iotCount_zero: "لا تحذيرات",
iotCount_one: "تحذير واحد",
iotCount_two: "تحذيران",
iotCount_few: "{{count}} تحذيرات",
iotCount_many: "{{count}} تحذيرًا",
iotCount_other: "{{count}} تحذير",
iotTitle: "تحذيرات إنترنت الأشياء",
iotEmpty: "لا توجد تحذيرات من إنترنت الأشياء.",
},
};
